var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"color":"dark","top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":"primary","small":""}},'v-icon',attrs,false),on),[_vm._v(" fa-question-circle ")])]}}])},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.i18n))}})])}
var staticRenderFns = []

export { render, staticRenderFns }